import { Container } from '@mantine/core';
import SectionTitle from '../SectionTitle/SectionTitle';
import { PricingColumn } from './_parts/PricingColumn/PricingColumn';
import { pricingData } from './Pricing.data';
import { BirthdayBanner, Row, Wrapper } from './Pricing.style';

export type PricingProps = {
  user: IUser;
  onPlanSelect: (planId: string) => void;
  birthday: boolean;
};

export function Pricing(props: PricingProps) {
  const { user, birthday } = props;
  const { planId } = user;

  const data = pricingData;
  const headerText = birthday
    ? 'Exclusive Birthday Deal: The Only Asset Pack That Keeps on Giving! 🎁'
    : 'Explore Our Monthly Plans and Join the Sloyd Community!';

  function renderPlan(plan: Json) {
    return (
      <PricingColumn
        key={plan.id}
        plan={plan}
        onPlanSelect={props.onPlanSelect}
        isCurrent={plan.dbPlanId === planId}
      />
    );
  }

  function renderPlans() {
    return data.map((plan: Json) => renderPlan(plan));
  }

  function renderBanner() {
    return (
      <BirthdayBanner>
        🎂 Crazy Spring Sale! 🎉 This Easter, get 67% off — two months for just $4.99 each! 🥳
      </BirthdayBanner>
    );
  }

  return (
    <Wrapper className='Pricing-wrapper' data-testid='Pricing-wrapper'>
      {renderBanner()}
      <Container size='lg'>
        <SectionTitle gradient={{ from: '#ff6a00', to: '#ee0979' }} title='Pricing Plans'>
          {headerText}
        </SectionTitle>
        <Row>{renderPlans()}</Row>
      </Container>
    </Wrapper>
  );
}

export default Pricing;
